import { PagesComponent } from './../components/pages/pages.component';
import { PageDetailComponent } from './../components/pages/page-detail.component';
import { FileDetailComponent } from './../components/files/file-detail.component';
import { FileBrowseComponent } from './../shared/components/browse/file-browse.component';
import { EntityBrowseComponent } from './../shared/components/browse/entity-browse.component';
import { PageTileDetailComponent } from './../components/pages/page-tile-detail.component';
import { ContentboxDetailComponent } from './../components/pages/contentbox.detail.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';
import { HomeTileDetailComponent } from './../components/homepage/hometile-detail.component';
import { AuthGuard } from './../shared/guards/auth.guard';
import { DesignboxDetailComponent } from '../components/pages/designbox.detail.component';
import { StoryboardDetailComponent } from '../components/pages/storyboard-detail.component';

export const pagesRoutes = {
    path: 'pages',
    data: {
        breadcrumbs: {
            label: 'Stránky',
            icon: 'pages'
        },
        state: 'pages'
    },
    children: [
        {
            path: '',
            component: PagesComponent
        },
        {
            path: 'add',
            data: {
                breadcrumbs: {
                    label: 'Přidat stránku'
                },
                state: 'page-add'
            },
            children: [
                {
                    path: '',
                    component: PageDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'pages-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'pages-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'pages-entities-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'pagetiles',
                    component: PageTileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Přidat dlaždici'
                        },
                        state: 'pages-pagetiles-add'
                    },
                    outlet: 'modal-form'
                },
                {
                    path: 'contentboxes',
                    component: ContentboxDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Přidat obsahový box'
                        },
                        state: 'contentboxes-add'
                    },
                    outlet: 'modal-form'
                },
                {
                    path: 'designboxes',
                    component: DesignboxDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Přidat designový box'
                        },
                        state: 'designboxes-add'
                    },
                    outlet: 'modal-form'
                },
                {
                    path: 'storyboards',
                    component: StoryboardDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Přidat storyboard'
                        },
                        state: 'storyboards-add'
                    },
                    outlet: 'modal-form'
                }
            ]
        },
        {
            path: 'edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit stránku'
                },
                state: 'page-edit'
            },
            children: [
                {
                    path: '',
                    component: PageDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'pages-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'pages-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'pages-entities-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'pagetiles',
                    component: PageTileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit dlaždici'
                        },
                        state: 'pages-pagetiles-edit'
                    },
                    outlet: 'modal-form'
                },
                {
                    path: 'contentboxes',
                    component: ContentboxDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit obsahový box'
                        },
                        state: 'contentboxes-edit'
                    },
                    outlet: 'modal-form'
                },
                {
                    path: 'designboxes',
                    component: DesignboxDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit designový box'
                        },
                        state: 'designboxes-edit'
                    },
                    outlet: 'modal-form'
                },
                {
                    path: 'storyboards',
                    component: StoryboardDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit storyboard'
                        },
                        state: 'storyboards-edit'
                    },
                    outlet: 'modal-form'
                }
            ]
        },
        {
            path: 'delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat stránku'
                },
                state: 'page-delete',
                apiUri: 'pages'
            },
            outlet: 'modal'
        },
        {
            path: 'tiles-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat dlaždici'
                },
                state: 'tile-delete',
                apiUri: 'pagetiles'
            },
            outlet: 'modal'
        },
        {
            path: 'contentboxes-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat box'
                },
                state: 'contentbox-delete',
                apiUri: 'contentboxes'
            },
            outlet: 'modal'
        },
        {
            path: 'designboxes-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat box'
                },
                state: 'designbox-delete',
                apiUri: 'designboxes'
            },
            outlet: 'modal'
        },
        {
            path: 'storyboards-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat box'
                },
                state: 'storyboard-delete',
                apiUri: 'storyboards'
            },
            outlet: 'modal'
        },
        {
            path: 'hometiles/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat dlaždici'
                },
                state: 'hometile-add'
            },
            children: [
                {
                    path: '',
                    component: HomeTileDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'hometiles-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'hometiles-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'tiles/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat dlaždici'
                },
                state: 'pagetile-add'
            },
            children: [
                {
                    path: '',
                    component: PageTileDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'tiles-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'tiles-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'contentboxes/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat obsahový box'
                },
                state: 'contentbox-add'
            },
            children: [
                {
                    path: '',
                    component: ContentboxDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'contentboxes-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'contentboxes-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'designboxes/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat design box'
                },
                state: 'designbox-add'
            },
            children: [
                {
                    path: '',
                    component: DesignboxDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'designboxes-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'designboxes-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'storyboards/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat storyboard'
                },
                state: 'storyboard-add'
            },
            children: [
                {
                    path: '',
                    component: StoryboardDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'storyboards-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'storyboards-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'tiles/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit dlaždici'
                },
                state: 'pagetile-edit'
            },
            children: [
                {
                    path: '',
                    component: PageTileDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'tiles-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'tiles-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'contentboxes/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit dlaždici'
                },
                state: 'pagetile-edit'
            },
            children: [
                {
                    path: '',
                    component: ContentboxDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'contentboxes-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'contentboxes-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'designboxes/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit dlaždici'
                },
                state: 'pagetile-edit'
            },
            children: [
                {
                    path: '',
                    component: DesignboxDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'designboxes-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'designboxes-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'storyboards/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit dlaždici'
                },
                state: 'pagetile-edit'
            },
            children: [
                {
                    path: '',
                    component: StoryboardDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'storyboards-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'storyboards-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        }
    ],
    canActivate: [AuthGuard]
};
